// Identificador do portal de reembolso: o mesmo campo aceita e-mail ou telefone.
// O backend espera { email } ou { phone } no get_token/confirm_email; telefone
// viaja só com dígitos (o backend normaliza DDI 55 e formatos históricos).

const NON_DIGITS = /\D/g;
const EMAIL_SHAPE = /^\S+@\S+\.\S+$/;
const STORAGE_KEY = 'refundIdentifier';

export function parseIdentifier(raw) {
  const value = (raw || '').trim();
  if (value.includes('@')) {
    return { type: 'email', value };
  }
  return { type: 'phone', value, digits: value.replace(NON_DIGITS, '') };
}

export function isValidIdentifier(raw) {
  const identifier = parseIdentifier(raw);
  if (identifier.type === 'email') {
    return EMAIL_SHAPE.test(identifier.value);
  }
  return identifier.digits.length >= 10 && identifier.digits.length <= 15;
}

export function identifierPayload(raw) {
  const identifier = parseIdentifier(raw);
  if (identifier.type === 'email') {
    return { email: identifier.value };
  }
  return { phone: identifier.digits };
}

export function formatIdentifier(raw) {
  const identifier = parseIdentifier(raw);
  if (identifier.type === 'email') {
    return identifier.value;
  }
  const national =
    identifier.digits.length > 11 && identifier.digits.startsWith('55')
      ? identifier.digits.slice(2)
      : identifier.digits;
  if (national.length === 11) {
    return `(${national.slice(0, 2)}) ${national.slice(2, 7)}-${national.slice(7)}`;
  }
  if (national.length === 10) {
    return `(${national.slice(0, 2)}) ${national.slice(2, 6)}-${national.slice(6)}`;
  }
  return identifier.value;
}

export function storeRefundIdentifier(raw) {
  try {
    localStorage.setItem(STORAGE_KEY, (raw || '').trim());
  } catch (error) {
    // storage indisponível (ex.: Safari privado): o header cai no e-mail da sessão
  }
}

export function readRefundIdentifier() {
  try {
    return localStorage.getItem(STORAGE_KEY) || '';
  } catch (error) {
    return '';
  }
}
